import { jsxs, jsx } from "react/jsx-runtime";
import React from "react";
import { useFocusRing } from "@react-aria/focus";
import styled, { css } from "styled-components";
import { token } from "./token.js";
import { textStyles } from "./textStyles.js";
import { TruncatedText } from "./TruncatedText.js";
import { RightElementText } from "./RightText.js";
import { Flex } from "./Flex.js";
function Item({
  as = "a",
  href,
  target = "_self",
  to,
  onClick,
  icon,
  children,
  rightElements,
  isDisabled = false,
  isActive = false,
  ...props
}) {
  const {
    isFocusVisible,
    focusProps
  } = useFocusRing();
  return /* @__PURE__ */ jsxs(StyledNavItem, {
    $isSelected: isActive,
    disabled: isDisabled,
    $isFocusVisible: isFocusVisible ? isFocusVisible : void 0,
    as,
    href,
    target: as === "a" ? target : void 0,
    to,
    onClick,
    role: "menuitem",
    ...focusProps,
    ...props,
    children: [icon && /* @__PURE__ */ jsx(LeftIconContainer, {
      children: icon
    }), /* @__PURE__ */ jsx(TruncatedText, {
      children
    }), rightElements && rightElements.length > 0 && /* @__PURE__ */ jsx(RightElementsContainer, {
      children: /* @__PURE__ */ jsx(Flex, {
        gap: "3",
        alignItems: "center",
        children: rightElements.map((rightElement, index) => (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ jsx(React.Fragment, {
            children: rightElement
          }, index)
        ))
      })
    })]
  });
}
const LeftIconContainer = styled.div.withConfig({
  displayName: "LeftIconContainer",
  componentId: "sc-mou1hp-0"
})(["margin-right:", ";*{max-width:24px;max-height:24px;}"], token.spacing4);
const RightElementsContainer = styled.div.withConfig({
  displayName: "RightElementsContainer",
  componentId: "sc-mou1hp-1"
})(["margin-left:auto;padding-left:", ";"], token.spacing4);
const NavItemActivePressed = css(["background-color:", " !important;color:", " !important;", "{color:", ";}"], token.gray50, token.gray800, RightElementText, token.gray600);
const StyledNavItem = styled.a.withConfig({
  displayName: "StyledNavItem",
  componentId: "sc-mou1hp-2"
})(["&&{", " display:flex;align-items:center;box-sizing:border-box;width:100%;height:40px;margin:0;padding:", " ", ";border:0;border-radius:", ";background:none;color:", ";outline:none;font-family:", ";text-decoration:none;cursor:", ";&:hover{background-color:", ";color:", ";", "{color:", ";}}&:active{", "}", " ", " ", ";}& + &{margin-top:", ";}"], textStyles.uiTextM, token.spacing3, token.spacing4, token.brandRadiusBase, token.gray600, token.brandFontStackBase, (props) => props.disabled ? "default" : "pointer", token.gray25, token.gray800, RightElementText, token.gray600, NavItemActivePressed, (props) => props.$isSelected && NavItemActivePressed, (props) => props.$isFocusVisible && css(["background-color:", ";color:", ";", "{color:", ";}"], token.gray25, token.gray800, RightElementText, token.gray600), (props) => props.disabled && css(["background-color:transparent;color:", ";pointer-events:none;", "{color:", ";}"], token.gray400, RightElementText, token.gray400), token.spacing1);
export {
  Item
};
//# sourceMappingURL=Item8.js.map
